import React, { useCallback, useMemo, useContext } from 'react';
import classNames from './NotificationsPopup.module.scss';
import { useTranslation } from 'react-i18next';
import { getNotificationText } from '@/context/NotificationsContext';
import AppModal from '@/components/AppModal/AppModal';
import Button from '@/components/school-management/Button/Button';
import { NotificationsContext } from '@/context/NotificationsContext';
import { triggerForcedSessionLogout } from '@/utils/forcedSessionLogout';
import DOMPurify from 'dompurify';

interface NotificationsPopupProps {}

const NotificationsPopup = ({}: NotificationsPopupProps) => {
  const { t } = useTranslation();
  const { showPopup, setShowPopup, popupNotification } = useContext(NotificationsContext);

  const { title, body, sendData } = useMemo(() => {
    return getNotificationText(popupNotification || null, t);
  }, [popupNotification, t]);

  const onClose = useCallback(() => {
    if (popupNotification?.eventType === 'levelChanged') {
      localStorage.setItem('skipLevelChangedMessage', 'true');
      window.location.reload();
      return;
    }

    if (
      popupNotification?.eventType === 'dealExpired' ||
      popupNotification?.eventType === 'accountDeleted' ||
      popupNotification?.eventType === 'studentGroupPlacementTestRequired' ||
      popupNotification?.eventType === 'movedToDifferentClassWithPlacementTestRequired' ||
      popupNotification?.eventType === 'studentGroupLevelSet' ||
      popupNotification?.eventType === 'movedToDifferentClassWithLevelSet'
    ) {
      setShowPopup(false);
      triggerForcedSessionLogout('/login');
      return;
    }

    setShowPopup(false);
  }, [setShowPopup, popupNotification]);

  return (
    <AppModal
      show={showPopup}
      className={classNames.modal}
      modalContentClassName={classNames.modalContent}
      type='fade'
      blockBodyScroll={true}
    >
      <div className={classNames.title}>{title}</div>
      <div className={classNames.bodyGroup}>
        <div
          className={classNames.description}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(body) }}
        />
        <div className={classNames.sendData}>{sendData}</div>
      </div>
      <div className={classNames.footer}>
        <Button className={classNames.button} onClick={onClose}>
          {t('notifications.popup.okButton')}
        </Button>
      </div>
    </AppModal>
  );
};

export default React.memo(NotificationsPopup);
